<template>
	<div class="left-box" :style="autoH ? 'height: auto;' : ''">
		<div class="left-title">
			<span style="cursor: pointer;" @click="titleClick">{{ title }}</span>
		</div>
		<div class="left-main">
			<!-- 单计量 -->
			<el-tree ref="singleTree" :data="singleData" :node-key="treeKey" :default-expand-all="true" :props="singleProps"
				:check-on-click-node="true" :expand-on-click-node="false" @node-click="onSingleSelect"
				@node-contextmenu="openMenu">
				<span class="custom-tree-node" slot-scope="{ node }">
					<span class="label" :title="node.label" :class="{ 'current-node': node.isCurrent }">
						<span> {{ node.label }}</span>
					</span>
					<span class="node-btn" v-if="showAction.indexOf('Create') != -1 && node.label == '单计量'">
						<!-- <el-button type="text" @click="singleCreate(data)" icon="el-icon-circle-plus-outline">
						</el-button> -->
					</span>
				</span>
			</el-tree>
			<!-- 多计量 -->
			<el-tree ref="moreTree" :data="moreData" :node-key="treeKey" :default-expand-all="true" :props="moreProps"
				:check-on-click-node="true" :expand-on-click-node="false" @node-click="onMoreSelect"
				@node-contextmenu="openMenu">
				<span class="custom-tree-node" slot-scope="{ node }">
					<span class="label" :title="node.label" :class="{ 'current-node': node.isCurrent }">
						<span>{{ node.label }}</span>
					</span>
					<span class="node-btn" v-if="showAction.indexOf('Create') != -1 && node.label == '多计量'">
						<!-- <el-button type="text" @click="moreCreate(data)" icon="el-icon-circle-plus-outline"></el-button> -->
					</span>
				</span>
			</el-tree>
		</div>
		<!--  -->
		<ul v-show="visible" :style="{ left: menu.left + 'px', top: menu.top + 'px' }" class="contextmenu">
			<li v-if="showAction.indexOf('Edit') != -1" @click="edit(menu.selectedTag)">编辑</li>
			<li v-if="showAction.indexOf('Delete') != -1" @click="del(menu.selectedTag)">删除</li>
		</ul>
		<!-- <more-dialog ref="editDialog" @close-saved="getData({ Pid: 0 })" /> -->
		<single-dialog ref="singleDialog" @close-saved="singReload" />
		<more-dialog ref="moreDialog" @close-saved="getData({ Pid: 0 })" />
	</div>
</template>
<script>
import moreDialog from "./moreDialog.vue";
import singleDialog from "./singleDialog.vue";
export default {
	components: { moreDialog, singleDialog },
	props: {
		treeKey: {
			type: String,
			default: "UnitId",
		},
		treeLabel: {
			type: String,
			default: "UnitName",
		},
		title: {
			type: String,
			default: "计量单位组",
		},
		delText: {
			type: String,
			default: "确定删除这个类别吗？",
		},
		showAction: {
			type: String,
			default: () => "Create|Edit|Delete",
		},
		parentClick: {
			type: Boolean,
			default: () => true,
		},
		autoH: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			api: require("@/api/ba/unit").default,
			unitGroupApi:require("@/api/ba/unitGroup").default,
			// api: require("@/api/ba/unit").default,
			singleData: [
				{
					UnitName: "单计量",
					children: [],
				},
			],
			moreData: [
				{
					Name: "多计量",
					children: [],
				},
			],
			treeData: [],
			singleProps: {
				children: "children",
				label: this.treeLabel,
			},
			moreProps: {
				children: "children",
				label: "Name",
			},
			nowId: null,
			visible: false,
			menu: {
				top: 0,
				left: 0,
				selectedTag: {},
			},
		};
	},
	watch: {
		visible(value) {
			value ? document.body.addEventListener("click", this.closeMenu) : document.body.removeEventListener("click", this.closeMenu);
		},
	},
	mounted() {
		this.getData({});
	},
	methods: {
		titleClick() {
			this.$emit("title-click");
			this.resetSelect();
		},
		singReload(){
			this.$parent.reload();
		},
		getData(params = {}) {
			// params = { ...params, ClassType: 8 };
			this.unitGroupApi.list({}).then((res) => {
				// this.singleData[0].children = res.Data.filter((item) => item.UnitGroupId === null && item.IsGroup === false);
				this.moreData[0].children = res.Data;
			});
		},
		resetSelect() {
			this.setKey(null);
		},
		setKey(key) {
			this.$refs.singleTree.setCurrentKey(key);
			this.$refs.moreTree.setCurrentKey(key);
		},
		// 创建单计量
		singleCreate(data) {
		
			this.$refs.singleDialog.openCreate();
		},
		// 创建多计量
		moreCreate(data) {
			console.log("create", data);
			let parent = {};
			if (data != undefined) {
				parent = {
					Pid: data[this.treeKey],
					Pname: data[this.treeLabel],
				};
			}
			this.$refs.moreDialog.openCreate(parent);
		},
		edit(data) {
			console.log('编辑',data);
		 	const name = data.IsSingleUnit ? 'singleDialog' :'moreDialog'
			this.$refs[name].openEdit(data) 
		},
		del(data) {
			console.log(data);
			this.$confirm(this.delText, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					// console.log('删除',data);
					// console.log('data[this.treeKey]',data[this.treeKey]);
					this.unitGroupApi.delete({Id:data.UnitGroupId}).then((res) => {
						console.log(res);
						if (res.Code == 0) {
							this.$message.success(res.Msg);
							this.getData();
						} else {
							this.$message.error(res.Msg);
						}
					});
				})
				.catch(() => { });
		},
		openMenu(e, data) {
			var actions = this.showAction.split("|");
			if (!actions.find((x) => x == "Edit" || x == "Delete")) {
				return;
			}
			const menuMinWidth = 105;
			const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
			const offsetWidth = this.$el.offsetWidth; // container width
			const maxLeft = offsetWidth - menuMinWidth + 56; // left boundary
			const left = e.clientX - offsetLeft + 70; // 15: margin right

			if (left > maxLeft) {
				this.menu.left = maxLeft;
			} else {
				this.menu.left = left;
			}

			this.menu.top = e.clientY;
			this.visible = true;
			this.menu.selectedTag = data;
		},
		closeMenu() {
			this.visible = false;
		},
		onSingleSelect(node, self) {
			console.log('单计量');
			node.mode = 0
			this.onSelect(node, self)
		},
		onMoreSelect(node, self) {
			console.log('多计量');
			node.mode = 1;
			this.onSelect(node, self)
		},
		onSelect(node, self, type) {
			if (this.parentClick) {
				this.nowId = node[this.treeKey];
				this.$emit("on-select", node);
			} else {
				if (node.children != undefined) {
					self.isCurrent = false;
				} else {
					this.nowId = node[this.treeKey];
					this.$emit("on-select", node);
				}
			}
		}

	}
};
</script>